module.exports = __webpack_public_path__ + "static/carousel-1-b205b97097257144145c838a13e94960.png";